import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createCrud, createQueryKey, useAxiosClient, useQuery } from '@lumahealthhq/ui-model';
var basePath = 'faxDocuments';
var crud = createCrud(basePath);

/* Default queries */
export var useFaxCount = crud.makeCount();
export var useFaxById = crud.makeFindById();
export var useFaxByIds = crud.makeFindByIds();
export var useFaxMany = crud.makeFindMany();
export var useFaxOne = crud.makeFindOne();
export var useFaxPagination = crud.makePagination();

/* Default mutations */
export var useFaxCreateOne = crud.makeCreateOne();
export var useFaxUpdateOne = crud.makeUpdateOne();
export var useFaxPatchOne = crud.makePatchOne();
export var useFaxRemoveById = crud.makeRemoveById();

/* Custom queries */
export function useFaxCountFromContentRange(params, options) {
  var axiosClient = useAxiosClient();
  var variant = 'v2/{basePath}';
  function queryFn() {
    return _queryFn.apply(this, arguments);
  }
  function _queryFn() {
    _queryFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _response$headers;
      var url, headers, response, contentRange, totalCount;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            url = variant.replace('{basePath}', basePath);
            headers = {
              'content-range': '0-1',
              'Cache-Control': 'no-cache'
            };
            _context.next = 4;
            return axiosClient.get(url, {
              params: _extends({
                _select: '_id',
                limit: 1
              }, params),
              headers: headers
            });
          case 4:
            response = _context.sent;
            contentRange = (((_response$headers = response.headers) == null ? void 0 : _response$headers['content-range']) || '').split('/');
            totalCount = parseInt(contentRange[1], 10);
            return _context.abrupt("return", totalCount);
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _queryFn.apply(this, arguments);
  }
  var queryKey = createQueryKey(basePath, variant, _extends({
    _select: '_id',
    limit: 1
  }, params));
  var query = useQuery(queryKey, queryFn, _extends({
    staleTime: 0
  }, options));
  return query;
}

/* Custom mutations */